<template>
    <div id="topicCount">
          <div class="app-inner">
             <div class="public-btn-small flex align-cen posta enposta">
            <div class="public-btn-small-plan"  @click="$util.reback('/teacheManage/questionList')" style="margin-left:0">
                返回
            </div>
            </div>
              <div class="public-tit flex align-cen" >
            <div class="public-tit-list">
                <i class="icon-al-application"></i>  题目正确率分析
            </div>
        </div>
         <div class="summaryOfTestPie">
                <div class="exam-pr-pie">
                <PieChart :option="PieChartOption" :pieID="1"></PieChart>
            </div>
            </div>
               <div class="public-tit flex align-cen"  style="margin-top:16px">
            <div class="public-tit-list">
                <i class="icon-al-application"></i>  题目答题记录
            </div>
            <div class="public-btn mft" @click="exportExcel(multipleSelection)">导出</div>
        </div>
          <div class="businessList-container">
        <div class="businessList-container-table">
                  <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
        <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column>
         <el-table-column  label="序号" align="center">
            <template slot-scope="scope">
              <div>{{scope.$index + 1}}</div>
            </template>
          </el-table-column>
            <el-table-column prop="examiner" label="考生" align="center">
          </el-table-column>
           <el-table-column prop="paperName" label="试卷" align="center">
          </el-table-column>
           <el-table-column  label="试题结果" align="center">
             <template slot-scope="scope">
          <div v-if="$route.query.type !=5">{{scope.row.doRight == '1' ? '做对' : '做错'}}</div>
              <div v-if="$route.query.type ==5">
                <div v-if="scope.row.userScore">
                  {{scope.row.doRight  == '1'  ? '做对' : '做错'}}
                </div>
                <div v-if="!scope.row.userScore">
                  批卷中
                </div>
                </div>
            </template>
          </el-table-column>
         <el-table-column  label="考试分数" align="center">
             <template slot-scope="scope">
              <div v-if="scope.row.userScore ">{{scope.row.userScore}}%</div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="userScore" label="试题得分" align="center">
            <template slot-scope="scope">
             <div  v-if="scope.row.userScore">{{scope.row.customeScore}}</div>
              <div v-else>-</div>
            </template>
          </el-table-column>
           <el-table-column  label="试卷结果" align="center">
             <template slot-scope="scope">
              <div v-if="scope.row.userScore">{{scope.row.result == '1' ? '及格' : '不及格'}}</div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="start_time" label="考试时间" align="center">
          </el-table-column>
        </el-table>
        </div>
          </div>
          </div>
    </div>
</template>
<script>
import { questionEnCount} from "@/api/enterprise/index"; // 题目统计详情
import PieChart from "../../../components/pieTemolate/index.vue"; //饼图组件
import exportExcel from '../../../utils/exportExcel.js' //导出数据公共方法
export default {
    name:'topicCount',
    components:{
      PieChart,
    },
    data () {
        return {
            PieChartOption:{},
            list:[],
            multipleSelection:[],
            businessInfo:{}
        }
    },
    created () {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getQuestionCount()
    },
    methods: {
          //导出
          exportExcel(val){ 
             if(val.length !=0){
        let keyLisst = [] 
            for(let item in val){
             keyLisst.push( {
              '试题ID':val[item].question_id, 
              '考生':val[item].examiner, 
              '试卷':val[item].paperName ,
              '试卷结果':`${val[item].doRight == '1' ? '做对' : '做错'}`,
              '考试分数':val[item].percentScore + '%',
              '试题得分':val[item].userScore,
              '试卷结果':`${val[item].result == '1' ? '做对' : '做错'}`,
              '考试时间':val[item].start_time ,
              } ) 
             }
         exportExcel.exportExcel(keyLisst,this.$route.meta.title)
             }else{
                this.$message.error('未选择导出数据')
             }
        },
        getQuestionCount(){
            questionEnCount({id:this.$route.query.id,businessId:this.businessInfo.id},'enterprise').then(res => {
                this.list = res.data.list
            let srdata = [
                { value: Number(res.data.wrongRate), name: '答错',num:Number(res.data.wrongNum) },
                { value: Number(res.data.rightRate), name: '答对',num:Number(res.data.rightNum)  }, 
                ]
                this.PieChartOption = {
                    title: {
                  text: '题目正确率',
                  left: 'center'
                },
                tooltip: {
                  trigger: 'item',
                  formatter:function(params){
                   
                    var str = '';
                     str = `${params.name}</br>次数：${params.data.num}</br>比例：${params.value}%`
                     return str
                  }
                },
                 legend: {
                orient: 'horizontal',
                left: 'auto'
              },
              color: ['#FF6969','#699DFF'],
                series: [
                    {
                      name: '考试成绩',
                      type: 'pie',
                      radius: '50%',
                      data: srdata,
                      emphasis: {
                        itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                      }
                    }
                  ]
                }
               
            })
        },
         getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    }
}
</script>
<style lang="scss" scoped>
#topicCount{
    margin-bottom: 70px;
      .summaryOfTestPie{
          margin-top: 36px;
          .exam-pr-pie{
            height: 400px;
            padding: 20px;
            border: 1px solid #e6e6e6;
            border-radius: 10px;
          }
        }
        .public-btn{
    min-width: 60px;
    cursor: pointer;
    color: #409eff;
    padding: 7px 10px;
    border-radius: 4px !important;
    text-align: center;
    border: none;
    background: #409eff;
    color: #fff;
        }
}
</style>